export default __webpack_public_path__ + "static/media/USDT (ERC20).b2137dd6.jpg";